/**
 * Utility functions for records-related operations
 */

import { RecordsResponse, TeamRecords } from "../types/records";

/**
 * Extracts team record for a specific team from records data
 * @param teamId - The ID of the team to get records for
 * @param recordsData - The records data containing all team records
 * @returns Team records for the specified team, or null if not found
 */
export const getTeamRecord = (
  teamId: number,
  recordsData: RecordsResponse | null
): TeamRecords | undefined => {
  if (!recordsData?.records?.[teamId]) {
    return undefined;
  }
  return recordsData.records[teamId];
};
